import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=10c167fe&scoped=true&lang=pug&"
import script from "./Draggable.vue?vue&type=script&lang=js&"
export * from "./Draggable.vue?vue&type=script&lang=js&"
import style0 from "./Draggable.vue?vue&type=style&index=0&id=10c167fe&lang=scss&scoped=true&"
import style1 from "./Draggable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c167fe",
  null
  
)

export default component.exports